"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps } from "sonner";
import { cn } from "@/lib/utils";
const Toaster = t0 => {
  const $ = _c(7);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  const {
    theme: t1
  } = useTheme();
  const theme = t1 === undefined ? "light" : t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      pointerEvents: "auto"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = theme as ToasterProps["theme"];
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      classNames: {
        actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
        cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        toast: cn("[--bg-opacity:10%] [--border-radius:var(--radius-xl)]", "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-[0px_0px_16px_8px_rgba(31,38,135,0.07)]", "[--normal-bg:var(--color-popover)] [--normal-border:color-mix(in_oklch,var(--color-border),transparent_40%)] [--normal-text:var(--color-popover-foreground)]", "[--error-bg:color-mix(in_oklch,var(--color-destructive),white_95%)] [--error-border:color-mix(in_oklch,var(--color-destructive),transparent_85%)] [--error-text:var(--color-destructive)]", "[--success-bg:color-mix(in_oklch,var(--color-success),white_90%)] [--success-border:color-mix(in_oklch,var(--color-success),transparent_80%)] [--success-text:var(--color-success)]", "[--info-bg:color-mix(in_oklch,var(--color-primary),white_95%)] [--info-border:color-mix(in_oklch,var(--color-primary),transparent_85%)] [--info-text:var(--color-primary)]", "[--warning-bg:color-mix(in_oklch,var(--color-orange),white_90%)] [--warning-border:color-mix(in_oklch,var(--color-orange),transparent_75%)] [--warning-text:var(--color-orange)]")
      }
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== props || $[5] !== t3) {
    t5 = <Sonner className="toaster group" position="top-right" style={t2} theme={t3} toastOptions={t4} visibleToasts={8} {...props} />;
    $[4] = props;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
export { Toaster };